module.exports = __webpack_public_path__ + "img/white.1a2eab2b.png";